import { h, Fragment, cn } from '../../../lib/vdom.js';
import { CONTACT_EMAIL_HREF } from './Contact.jsx';
import * as I from './Icon.jsx';

export default function Intro() {
  return (
    <section id="intro">
      <div className="content-wrapper">
        <div className="content">
          <h2>GROW YOUR BUSINESS</h2>
          <h1>
            Custom Software
            <br />
            Development
          </h1>
          <p>
            Web applications, internal tools, automation,
            <br />
            and integrations designed for your business.
          </p>
          <div className="button-container">
            <a className="book-button inverse" href={CONTACT_EMAIL_HREF}>
              <I.IconEmail /> SEND AN EMAIL
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export function initIntro() {
  const intro = document.getElementById('intro')!;
  document.addEventListener('scroll', scrolled);

  // Hide intro in the background when scrolling down otherwise
  // on ios when we overscroll the bottom edge it'll appear in
  // the background.
  function scrolled() {
    if (window.scrollY > intro.getBoundingClientRect().height * 2) {
      intro.style.visibility = 'hidden';
    } else {
      intro.style.visibility = 'visible';
    }
  }
}
